import StratificationService from "@/pages/common/trend/service/StratificationService";
import StratificationActions from "./StratificationActions";
import StratificationGetters from "./StratificationGetters";
import StratificationMutations from "./StratificationMutations";

const state = StratificationService.EmptyStratificationStatefactory();

const { actions } = StratificationActions;

const { mutations } = StratificationMutations;

const { getters } = StratificationGetters;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	getters,
	mutations,
};
